import { render } from "./ButtonModals.vue?vue&type=template&id=ac22544a&scoped=true"
import script from "./ButtonModals.vue?vue&type=script&lang=js"
export * from "./ButtonModals.vue?vue&type=script&lang=js"

import "./ButtonModals.vue?vue&type=style&index=0&id=ac22544a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac22544a"]])

export default __exports__